import axios from 'axios'
import store from '../vuex/store'
import router from './router.js'

const GENERAL = axios.create({})

const ACCESS = axios.create({})

const REVOKE = axios.create({})

const CONFIRM = axios.create({})

const AT_EXPIRES_IN = 30 * 60 * 1000

GENERAL.interceptors.response.use(
    (response) => {
        let now = (new Date()).getTime()
        localStorage.setItem('last_active', now)
        return response
    }
)

ACCESS.interceptors.request.use(
    (request) => {
        // console.log('access', request)
        let now = (new Date()).getTime()
        let last_active = localStorage.getItem('last_active')
        let refresh_token = localStorage.getItem('refresh_token')
            // console.log(last_active, now, AT_EXPIRES_IN, now - last_active)
        if (!!refresh_token) {
            request.headers['Authorization'] = 'JWT ' + store.getters['auth/access_token']
            return request
        } else {
            // TODO: get a refresh token from cookie
            return store.dispatch('auth/logout')
        }
    },
    (error) => {
        return Promise.reject(error)
    }
)

ACCESS.interceptors.response.use(
    (response) => {
        let now = (new Date()).getTime()
        localStorage.setItem('last_active', now)
        return response
    },
    (error) => {
        const original_request = error.config
        const status = error.response ? error.response.status : null
            // console.log('original_request', original_request, status)

        if (status == 401 || status == 422) {
            if (original_request._retry) {
                return store.dispatch('auth/logout')
            } else {
                original_request._retry = true
                let refresh_token = localStorage.getItem('refresh_token')
                if (!!refresh_token) {
                    store.commit('auth/setRefreshToken', refresh_token)
                    return store.dispatch('auth/updateToken')
                        .then(res => {
                            original_request.headers['Authorization'] = 'JWT ' + res
                            return ACCESS.request(original_request)
                        })
                } else {
                    // TODO: get a refresh token from cookie
                    return store.dispatch('auth/logout')
                }
            }
        }
        return Promise.reject(error)
    }
)

REVOKE.interceptors.request.use(
    (request) => {
        // console.log('revoke')
        if (request.url == '/api/logout/access') {
            request.headers['Authorization'] = 'JWT ' + store.getters['auth/access_token']
        } else if (request.url == '/api/logout/refresh') {
            request.headers['Authorization'] = 'JWT ' + store.getters['auth/refresh_token']
        }
        return request
    },
    (error) => {
        return Promise.reject(error)
    }
)

REVOKE.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        return Promise.reject(error)
    }
)

CONFIRM.interceptors.request.use(
    (request) => {
        // console.log('confirm')
        if (request.url == '/api/token/refresh') {
            request.headers['Authorization'] = 'JWT ' + store.getters['auth/refresh_token']
        } else {
            request.headers['Authorization'] = 'JWT ' + store.getters['auth/access_token']
        }
        return request
    },
    (error) => {
        return Promise.reject(error)
    }
)

CONFIRM.interceptors.response.use(
    (response) => {
        let now = (new Date()).getTime()
        localStorage.setItem('last_active', now)
        return response
    },
    (error) => {
        return Promise.reject(error)
    }
)

export default {
    GENERAL,
    ACCESS,
    REVOKE,
    CONFIRM,
}


// WEBPACK FOOTER //
// ./src/config/axios.js